import React from "react";
import ImgDev from "../assets/expert04.png";
import { useTranslation } from "react-i18next";

const AboutUs = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div id={id} className="w-full py-28 text-white px-4 bg-gray-800 overflow-hidden">
      <div className="max-w-[1240px] mx-auto flex flex-col md:flex-row items-center">
        {/* Image section */}
        <div
          className="w-full md:w-1/3 flex justify-center mb-8 md:mb-0"
          data-aos="fade-left"
        >
          <img
            src={ImgDev}
            alt={t("about.imgAlt")}
            className="rounded-lg shadow-lg w-full h-64 object-cover"
          />
        </div>
        {/* Text section */}
        <div className="w-full md:w-2/3 md:pl-12" data-aos="fade-right">
          <p className="text-gray-300 mt-4">{t("about.p1")}</p>
          <p className="text-gray-300 mt-4">{t("about.p2")}</p>
          <p className="text-gray-300 mt-4">{t("about.p3")}</p>
          <p className="text-gray-300 mt-4">{t("about.p4")}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
